import React, { useState, useEffect, useContext, useMemo } from "react";
import { Button, Box, Tab, Tabs } from "@mui/material";
import Typography from '@mui/material/Typography';
import LogoSettings from "components/LogoSettings";
import HourTypeSettings from "components/HourTypeSettings";
import ContractSettings from "components/ContractSettings";
import ContractUsers from "components/ContractUsers";
import CalendarSettings from "components/CalendarSettings";
import PlanSettings from "components/PlanSettings";
import CompanyDetailSettings from "components/CompanyDetailSettings";
import Communication from "area/employer/Communication";
import Compliance from "area/employer/Compliance";
import ComplianceReportTable from "components/Content/Table/ComplianceReportTable";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

// yeah, I know names, amiright??
const settingSettings = [
    {
        label: "Company Details",
        value: "companyDetails",
        platforms: [
            { name: "AXIM-MANAGED", isReadonly: true },
            { name: "CHECK+" },
            { name: "CHECK+MANAGED", isReadonly: true },
            { name: "CHECK" }
        ],
        groupType: [
            { name: "FSG" },
            { name: "GSG" },
            { name: "Combo" }
        ]
    },
    {
        label: "Company Logo",
        value: "logo",
        platforms: [
          { name: "AXIM-MANAGED", isReadonly: true },
          { name: "CHECK+" },
          { name: "CHECK+MANAGED", isReadonly: true },
          { name: "CHECK" }
        ],
        groupType: [
            { name: "FSG" },
            { name: "GSG" },
            { name: "Combo" }
        ]
    },
    {
        label: "Hour Types",
        value: "hourtypes",
        platforms: [
          { name: "AXIM-MANAGED", isReadonly: true },
          { name: "CHECK+" },
          { name: "CHECK+MANAGED", isReadonly: true },
          { name: "CHECK" }
        ],
        groupType: [
            { name: "FSG" },
            { name: "Combo" }
        ]
    },
    {
        label: "Contracts",
        value: "contracts",
        platforms: [
          { name: "AXIM-MANAGED", isReadonly: true },
          { name: "CHECK+" },
          { name: "CHECK+MANAGED", isReadonly: true },
          { name: "CHECK" }
        ],
        groupType: [
            { name: "FSG" },
            { name: "Combo" }
        ]
    },
    {
        label: "Calendar",
        value: "calendar",
        platforms: [
          { name: "AXIM-MANAGED", isReadonly: true },
          { name: "CHECK+" },
          { name: "CHECK+MANAGED", isReadonly: true },
          { name: "CHECK" }
        ],
        groupType: [
            { name: "FSG" },
            { name: "Combo" }
        ]
    },
    {
        label: "Benefit Plans",
        value: "plans",
        platforms: [
          { name: "AXIM-MANAGED", isReadonly: true },
          { name: "CHECK+" },
          { name: "CHECK+MANAGED", isReadonly: true },
          { name: "CHECK" }
        ],
        groupType: [
            { name: "FSG" },
            { name: "GSG" },
            { name: "Combo" }
        ]
    },
    {
        label: "Email Templates",
        value: "emailtemplates",
        platforms: [
          { name: "AXIM-MANAGED", isReadonly: true },
          { name: "CHECK+" },
          { name: "CHECK+MANAGED", isReadonly: true },
          { name: "CHECK" }
        ],
        groupType: [
            { name: "FSG" },
            { name: "GSG" },
            { name: "Combo" }
        ]
    },
    {
        label: "Compliance",
        value: "compliance",
        platforms: [
          { name: "CHECK+" },
          { name: "CHECK" }
        ],
        groupType: [
            { name: "FSG" },
            { name: "Combo" }
        ]
    },
    {
        label: "Report",
        value: "report",
        platforms: [
          { name: "CHECK+" },
          { name: "CHECK" }
        ],
        groupType: [
            { name: "FSG" },
            { name: "Combo" }
        ]
    },
];

function Settings (props) {
    const { userInfo } = useContext(PrivateRoutesContext);

    const [currentTab, setCurrentTab] = useState('');
    const [refresh, setRefresh] = useState(
        {
            hourType: 0,
            contracts: 0,
            contractUsers: 0,
            calendar: 0,
            plans: 0,
            companyDetails: 1,
            emailTemplates: 0,
            logo: 0,
        },
    );

    const isAdmin = useMemo(() => {
        return userInfo && userInfo.roles && userInfo.roles.some(r => ['ADMIN-SYS-ADMIN','ADMIN-SYS-MANAGER'].includes(r));
    }, [userInfo])

    const [isLoading, setIsLoading] = useState(true);
    const [shownContractSettings, setShownContractSettings] = useState('contracts');

    useEffect(() => {
        if (isLoading) {
            setIsLoading(false);
        }
    }, []);

    const tabs = useMemo(() => {
        let t = [];

        let groupType = userInfo?.companyDetails?.groupType;
        let platformName = userInfo?.companyDetails?.platformName;

        for (var i = 0; i < settingSettings.length; i++) {
            var setting = settingSettings[i];

            var foundPlatform = setting.platforms.find(p => p.name === platformName)
            var foundGroupType = setting.groupType.find(g => g.name === groupType)

            if (foundPlatform) {
                 t.push({ label: setting.label, value: setting.value, isReadonly: foundPlatform.isReadonly || foundGroupType?.isReadonly, icon: setting.icon });
            }
            //OLD CONDITION
            // if (foundPlatform && foundGroupType) {
            //     t.push({ label: setting.label, value: setting.value, isReadonly: foundPlatform.isReadonly || foundGroupType.isReadonly });
            // }else if(foundPlatform && !foundGroupType){
            //     t.push({ label: setting.label, value: setting.value, isReadonly: foundPlatform.isReadonly || foundGroupType.isReadonly });
            // }
        }

        return t;
    },[userInfo])

    useEffect(() => {
        if (tabs.length > 0) {
            handleChange(null, tabs[0].value);
        }
    },[tabs])

    const handleChangeToContractUsers = (event, newValue) => {
        setCurrentTab('contracts');
        setRefresh({...refresh, contractUsers:refresh.contractUsers+1,contracts:0})
    }

    const handleChange = (event, newValue) => {
        setCurrentTab(newValue);
        switch (newValue) {
        case 'hourtypes':
            setRefresh({...refresh, hourType:refresh.hourType+1})
            break;
        case 'contracts':
            setShownContractSettings('contracts');
            break;
        case 'calendar':
            setRefresh({...refresh, calendar:refresh.calendar+1})
            break;
        case 'plans':
            setRefresh({...refresh, plans:refresh.plans+1})
            break;
        case 'companyDetails':
            setRefresh({...refresh, companyDetails:refresh.companyDetails+1})
            break;
        case 'emailtemplates':
            setRefresh({...refresh, emailTemplates:refresh.emailTemplates+1})
            break;        
        case 'logo':
            setRefresh({...refresh, logo:refresh.logo+1})
            break;
        case 'compliance':
            break;
        case 'report':
            break;
        default:
            break;
        }
    };
    
    const getIsReadonly = (tabName) => {
        var tab = tabs.find(s => s.value === tabName);

        var isReadonly = tab?.isReadonly || false;

        return isReadonly;
    }

    return (
        <>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    {currentTab !== "" ?
                        <Tabs value={currentTab} onChange={handleChange} aria-label="settings tabs" centered>
                            {tabs.map(t => <Tab label={t.label} value={t.value} />)}
                        </Tabs> : null}
                </Box>

                <div
                    role="tabpanel"
                    hidden={currentTab !== 'companyDetails'}
                >
                    <Box sx={{ p: 3 }}>
                        {refresh.companyDetails > 0 ?
                            <CompanyDetailSettings
                                refresh={refresh.companyDetails}
                                groupType={userInfo?.companyDetails?.groupType}
                            />
                        : ""}
                    </Box>
                </div>

                <div
                    role="tabpanel"
                    hidden={currentTab !== 'logo'}
                >
                    <Box sx={{ p: 3 }}>
                        <Typography>
                            {refresh.logo > 0 ? <LogoSettings /> : ""}
                        </Typography>
                    </Box>
                </div>

                <div
                    role="tabpanel"
                    hidden={currentTab !== 'hourtypes'}
                >
                    <Box sx={{ p: 3 }}>
                        {refresh.hourType > 0 ?
                            <HourTypeSettings
                                refresh={refresh.hourType}
                                isAdmin={isAdmin}
                                isReadonly={getIsReadonly('hourtypes')}
                            />
                        : ""}
                    </Box>
                </div>

                <div
                    role="tabpanel"
                    hidden={currentTab !== 'contracts'}
                >
                    <Box sx={{ p: 3 }}>
                        {shownContractSettings === "contracts" ?
                            <ContractSettings
                                isVisible={currentTab === 'contracts'}
                                changeTab = {setShownContractSettings} 
                                isReadonly={getIsReadonly('contracts')}
                                isAdmin={isAdmin}
                            />
                        : ""}
                        {shownContractSettings === "contractUsers" ?
                            <ContractUsers
                                isVisible={currentTab === 'contracts'}
                                changeTab = {setShownContractSettings}
                                isReadonly={getIsReadonly('contracts')}
                                isAdmin={isAdmin}
                            />
                        : ""}
                    </Box>
                </div>

                <div
                    role="tabpanel"
                    hidden={currentTab !== 'calendar'}
                >
                    <Box sx={{ p: 3 }}>
                        {refresh.calendar > 0 ?
                            <CalendarSettings
                                refresh={refresh.calendar}
                                isReadonly={getIsReadonly('calendar')}
                                isAdmin={isAdmin}
                            />
                        : ""}
                    </Box>
                </div>

                <div
                    role="tabpanel"
                    hidden={currentTab !== 'plans'}
                >
                    <Box sx={{ p: 3 }}>
                        {refresh.plans > 0 ?
                            <PlanSettings
                                refresh={refresh.plans}
                                isReadonly={getIsReadonly('plans')}
                                isAdmin={isAdmin}
                            />
                        : ""}
                    </Box>
                </div>

                <div
                    role="tabpanel"
                    hidden={currentTab !== 'emailtemplates'}
                >
                    <Box sx={{ p: 3 }}>
                        {refresh.emailTemplates > 0 ?
                            <Communication 
                                isVisible={currentTab === 'emailtemplates'}
                                isReadonly={getIsReadonly('emailtemplates')}
                                isAdmin={isAdmin}
                            />
                        : ""}
                    </Box>
                </div>

                <div
                    role="tabpanel"
                    hidden={currentTab !== 'compliance'}
                >
                    <Box sx={{ p: 3 }}>
                        <Compliance
                            isVisible={currentTab === 'compliance'}
                            isReadonly={getIsReadonly('compliance')}
                            isAdmin={isAdmin}
                        />
                    </Box>
                </div>

                <div
                    role="tabpanel"
                    hidden={currentTab !== 'report'}
                >
                    <Box sx={{ p: 3 }}>
                        <ComplianceReportTable
                            isVisible={currentTab === 'report'}
                            isReadonly={getIsReadonly('report')}
                            isAdmin={isAdmin}
                        />
                    </Box>
                </div>
            </Box>
        </>
    );
}

export default Settings;
